(function () {
  "use strict";

  var TRACKED_PATHS = {
    "/collections/fireclay-farmhouse-sink": true,
    "/collections/33-inch-fireclay-farmhouse-sink": true,
    "/collections/30-inch-fireclay-farmhouse-sink": true,
    "/collections/fireclay-workstation-sinks": true,
    "/products/33-inch-ribbed-fireclay-farmhouse-workstation-sink": true,
    "/products/33-inch-fireclay-double-bowl-farmhouse-sink": true,
    "/products/30-inch-grooved-fireclay-farmhouse-sink": true,
    "/products/33-inch-reversible-apron-fireclay-farmhouse-sink": true,
    "/products/33-inch-smooth-apron-fireclay-farmhouse-sink": true,
    "/products/30-inch-reversible-apron-fireclay-farmhouse-sink": true
  };
  var MEASUREMENT_ID = "G-4RHBM1R7CN";
  var path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  var auditOrPreview = /(?:^|[?&])(?:preview_theme_id|read_depth_[^=]*)=/.test(window.location.search || "");

  if (!TRACKED_PATHS[path] || auditOrPreview || window.__nozlooReadDepthV1) return;
  window.__nozlooReadDepthV1 = true;

  var started = false;
  var sent = false;
  var maxBottom = 0;
  var consentRetries = 0;

  function sendToGoogle(eventName, params) {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
      return true;
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(["event", eventName, params]);
      return true;
    }
    return false;
  }

  /* 2026-08-18 fix: on desktop (>=990px) `.page-wrapper` is the scroll container; reading
     document.scrollingElement there returned a frozen 0, so every desktop session reported
     the same fabricated read-depth bucket. Mirror assets/scroll-container.js. */
  function scrollContainer() {
    if (window.matchMedia && window.matchMedia("(min-width: 990px)").matches) {
      return document.querySelector(".page-wrapper") || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function measure() {
    var root = scrollContainer();
    var top = root ? root.scrollTop : (window.pageYOffset || 0);
    maxBottom = Math.max(maxBottom, top + (window.innerHeight || 0));
  }

  function documentHeight() {
    var body = document.body;
    var root = document.documentElement;
    return Math.max(
      root ? root.scrollHeight : 0,
      root ? root.offsetHeight : 0,
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
      window.innerHeight || 0
    );
  }

  function finalBucket() {
    measure();
    var height = documentHeight();
    if (!height) return 0;
    var raw = Math.max(0, Math.min(100, (maxBottom / height) * 100));
    return Math.max(0, Math.min(100, Math.floor(raw / 10) * 10));
  }

  function send() {
    if (!started || sent) return;
    var bucket = finalBucket();
    sent = sendToGoogle("nozloo_read_" + bucket, {
      send_to: MEASUREMENT_ID,
      page_path: path,
      page_location: window.location.href,
      transport_type: "beacon",
      non_interaction: true
    });
  }

  function start() {
    if (started) return;
    started = true;
    measure();
    window.addEventListener("scroll", measure, { passive: true });
    document.addEventListener("scroll", measure, { passive: true, capture: true });
    window.addEventListener("resize", measure, { passive: true });
    window.addEventListener("pagehide", function (event) {
      if (!event.persisted) send();
    });
    document.addEventListener("freeze", send);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") send();
    });
  }

  function consentAllowed() {
    return Boolean(
      window.Shopify
      && Shopify.customerPrivacy
      && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === "function"
      && Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function bootWithConsent() {
    if (consentAllowed()) {
      start();
      return;
    }
    if (window.Shopify && typeof Shopify.loadFeatures === "function") {
      Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (!error && consentAllowed()) start();
        }
      );
    } else if (consentRetries < 20) {
      consentRetries += 1;
      window.setTimeout(bootWithConsent, 250);
    }
  }

  document.addEventListener("visitorConsentCollected", function () {
    if (consentAllowed()) start();
  });
  bootWithConsent();
})();
